import React, { useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './landing.page.css';
import { AccessType } from '../../model/Reformulary';
import  GetLangConfig  from '../../util/LangUtil';
interface HandleError {
    handleError: Function;
}
export default function LandingPage(pros: HandleError) {
    const history = useNavigate();
    const langConfig = GetLangConfig('landing');
    const userId = JSON.parse(sessionStorage.getItem('userId') || 'null');
    const userIdentityObject = JSON.parse(sessionStorage.getItem('userIdentityObject') || 'null');

    useEffect(() => {
        if (userId !== null) {
            const role = userId.role;

            if (role === AccessType[AccessType.MEMBER_CLAIMANT_ACCESS] || role === AccessType[AccessType.NON_MEMBER_CLAIMANT_ACCESS]) {
                history('/dashboard');
            } else if (role === AccessType[AccessType.ADMIN_ACCESS]) {
                history('/admin/dashboard');
            } else if (role === AccessType[AccessType.ASSESSOR_ACCESS]) {
                history('/assessor/dashboard');
            }
        }
    }, []);


    useLayoutEffect(()=>{
        const body = document.querySelector('body');
        if (body) {
            body.style.background = 'url(\'/images/landing-bg.jpg\') no-repeat';
            body.style.backgroundSize = 'cover';
            //body.style.backgroundPosition = '-300px';
        }

        return ()=>{
            if (body) {

                body.style.background = '';
                body.style.backgroundSize = '';
            }
        };

    });

    return (
        <div className="landing-page-container">
            <div>
                <img src={langConfig.general.landinglogo} />
                <p>{langConfig.landing.header}</p>
                <div>
                    <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={e=>history('/login')}>
                        <div className="mdc-button__ripple"></div>
                        <span className="mdc-button__label">{langConfig.landing.login}</span>
                    </button>
                    <div>OR</div>
                    <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={e=>history('/register')}>
                        <div className="mdc-button__ripple"></div>
                        <span className="mdc-button__label">{langConfig.landing.createAccount}</span>
                    </button>
                </div>
            </div>

        </div>
    );
}
